<app-bread-crump *ngIf="decoration" [title]="translateService.currentLang === 'en' ? decoration.nameEN : decoration.nameAR"
  [description]="translateService.currentLang === 'en' ? decoration.descEN : decoration.descAR" [items]="[
    { label:('Nav.Home' | translate), url: '/home' },
    { label:('home.quranDecorations' | translate), url: '/quran-decorations' },
    { label: translateService.currentLang === 'en' ? decoration.nameEN : decoration.nameAR }
  ]">
</app-bread-crump>

<section class="container d-flex flex-column my-5" style="max-width: 1280px">

  @if (loading()) {
  <div class="text-center my-5">
    <span>{{ 'COMMON.loading' | translate }}</span>
  </div>
  } @else {
  <div class="global-cards-row home" style="margin-block: 40px;">
    @for (quran of qurans; track quran.id) {
    <div class="global-cards-row__container">
      <app-index-card [item]="quran" />
    </div>
    }
  </div>

  @if (qurans.length === 0) {
  <div class="text-center my-5">
    <p>{{ 'noItemsFound' | translate }}</p>
  </div>
  }

  @if (pagination.totalPages > 1) {
  <div class="mt-4">
    <app-browse-paginator [pagination]="pagination" (pageChange)="onPageChange($event)">
    </app-browse-paginator>
  </div>
  }
  }
</section>
